export const name = process.env._PACKAGE_NAME_ as string;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const version = process.env._PACKAGE_VERSION_ as string;
